export const getDaysSince = (target_date: string) => {
  const diffMs = Date.now() - new Date(target_date).getTime();
  return Math.floor(Math.max(diffMs / (1000 * 60 * 60 * 24), 0));
};

export const dateToDaysAgoString = (base_date: string) => {
  const daysAgo = getDaysSince(base_date);
  if (daysAgo === 0) {
    return 'today';
  } else if (daysAgo === 1) {
    return '1 day ago';
  } else {
    return `${daysAgo} days ago`;
  }
};
